import React, { useState, useEffect } from 'react';
import { FaArrowCircleUp } from 'react-icons/fa';
import './ScrollToTopButton.css';

function ScrollToTopButton() {
  const [hovered, setHovered] = useState(false);
  const [isInFooter, setIsInFooter] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const footerElement = document.querySelector('footer'); // Select your footer element
      const footerTop = footerElement.getBoundingClientRect().top;

      if (footerTop < window.innerHeight) {
        setIsInFooter(true);
      } else {
        setIsInFooter(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div
      className="scroll-to-top-button"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={scrollToTop}
    >
      {hovered && (
        <span className={`scroll-to-top-text ${isInFooter ? 'footer-text' : ''}`}>
          Move to Top
        </span>
      )}
      <FaArrowCircleUp 
        size={50} 
        color="rgb(37,211,102)" 
        style={{ cursor: 'pointer' }}
      />
    </div>
  );
}

export default ScrollToTopButton;
